import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Typography, Button, Box, Grid, TextField, MenuItem } from '@material-ui/core';

const FirmaBienestar = ({ 
    firmaRefEntrevistado, 
    firmaRefResponsable, 
    limpiarFirma, 
    requiereDobleFirma = true,
    tipoFase,
    data, 
    onChange, 
    onError,
    profesionalesOpciones = [],
    readOnly = false,
}) => {
    
    const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
    const fecha = new Date();
    const textoFecha = `Se firma en Barranquilla a los ${fecha.getDate()} días del mes de ${meses[fecha.getMonth()]} del año ${fecha.getFullYear()}.`;
    const safeValue = (field) => (data && data[field] ? data[field].valor : '');
    const safeError = (field) => (data && data[field] ? data[field].error : '');

    const getEtiquetaResponsable = () => {
        if (tipoFase === 'T_1' || tipoFase === 'T_2') {
            return 'Coordinación de la Ruta de Atención';
        }
        if (tipoFase === 'F1_001' || tipoFase === 'F2_004') {
            return 'Responsable de la entrevista';
        }
        if (tipoFase === 'F2_005') {
            return 'Entrevistador/a';
        }
        return 'Responsable de la atención';
    };

    const getEtiquetaEntrevistado = () => {
        if (tipoFase === 'F2_004' || tipoFase === 'F2_005') {
            return 'Entrevistado/a';
        }
        return 'Firma';
    };

    return (
        <Box>
            <Grid container spacing={4} justify="center">
            
                    <Grid item xs={12} md={8}>
                        <TextField
                            fullWidth
                            required
                            select
                            label="Responsable de la atención (Funcionario)"
                            name="responsable_atencion"
                            value={safeValue('responsable_atencion')}
                            onChange={onChange}
                            disabled={readOnly}
                            error={!!safeError('responsable_atencion')}
                            helperText={safeError('responsable_atencion') || "Selecciona el profesional"}
                        >
                            {(Array.isArray(profesionalesOpciones) && profesionalesOpciones.length > 0) ? (
                                profesionalesOpciones.map((prof) => (
                                    <MenuItem key={prof.value} value={prof.label}>
                                        {prof.label}
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>No hay profesionales disponibles</MenuItem>
                            )}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            required
                            label="T.P. Responsable"
                            name="tp_responsable"
                            value={safeValue('tp_responsable')}
                            onChange={onChange}
                            disabled={readOnly}
                            error={!!safeError('tp_responsable')}
                            helperText={safeError('tp_responsable')}
                        />
                    </Grid>
   
                {/* FIRMA 1: Usuario / Solicitante / Entrevistado */}
                <Grid item xs={12} md={requiereDobleFirma ? 6 : 10}>
                    <Typography variant="subtitle2" align="center" gutterBottom style={{ fontWeight: 'bold' }}>
                        {requiereDobleFirma ? getEtiquetaEntrevistado().toUpperCase() : getEtiquetaResponsable().toUpperCase()}
                    </Typography>
                    
                    <div style={{ border: '2px solid #bbb', backgroundColor: '#f9f9f9', borderRadius: '4px', pointerEvents: readOnly ? 'none' : 'auto', opacity: readOnly ? 0.85 : 1 }}>
                        <SignatureCanvas
                            ref={firmaRefEntrevistado}
                            penColor="black"
                            canvasProps={{ height: 200, style: { width: '100%', display: 'block' } }}
                        />
                    </div>
                    
                    {!readOnly && (
                    <Button 
                        size="small" 
                        variant="outlined" 
                        color="secondary"  
                        onClick={() => limpiarFirma(firmaRefEntrevistado)} 
                        style={{ marginTop: 8 }}
                    >
                        Limpiar Firma
                    </Button>
                    )}
                </Grid>

                {/* FIRMA 2: Solo si requiereDobleFirma es true */}
                {requiereDobleFirma && (
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" align="center" gutterBottom style={{ fontWeight: 'bold' }}>
                            {getEtiquetaResponsable().toUpperCase()}
                        </Typography>
                        
                        <div style={{ border: '2px solid #bbb', backgroundColor: '#f9f9f9', borderRadius: '4px', pointerEvents: readOnly ? 'none' : 'auto', opacity: readOnly ? 0.85 : 1 }}>
                            <SignatureCanvas
                                ref={firmaRefResponsable}
                                penColor="black"
                                canvasProps={{ height: 200, style: { width: '100%', display: 'block' } }}
                            />
                        </div>
                        
                        {!readOnly && (
                        <Button 
                            size="small" 
                            variant="outlined" 
                            color="secondary" 
                            onClick={() => limpiarFirma(firmaRefResponsable)} 
                            style={{ marginTop: 8 }}
                        >
                            Limpiar Firma Responsable
                        </Button>
                        )}
                    </Grid>
                )}
            </Grid>

            <Typography variant="body1" style={{ marginBottom: '25px', marginTop: '25px', fontStyle: 'italic', textAlign: 'center' }}>
                {textoFecha}
            </Typography>
            

        </Box>
    );
};

export { FirmaBienestar };